import { z } from "zod";
import { doubleEncode, makeGetRequest } from "../../utils";

type GetSessionLiveStreamDetailsOptions = {
	/**
	 * The session's ID. If the ID begins with a / character or contains // characters, you must double-encode the ID value.

Examples: KkMHZ4y8QhSUWAHi5sWvfg==
	 */
	sessionId: string;
};

export const getSessionLiveStreamDetailsResponseSchema = z
	.object({
		stream_url: z.string(),
		stream_key: z.string(),
		page_url: z.string(),
		resolution: z.string(),
	})
	.deepPartial();
type GetSessionLiveStreamDetailsResponse = z.infer<
	typeof getSessionLiveStreamDetailsResponseSchema
>;

/**Use this API to return a session's live stream configuration details, such as the stream's URL, key, and page URL. */
const getSessionLiveStreamDetails = async (
	token: string,
	options: GetSessionLiveStreamDetailsOptions,
): Promise<GetSessionLiveStreamDetailsResponse> => {
	const res = await makeGetRequest({
		token,
		pathList: [
			"v2",
			"videosdk",
			"sessions",
			doubleEncode(options.sessionId),
			"livestream",
		],
		options: { ...options },
	});
	const parsed = getSessionLiveStreamDetailsResponseSchema.parse(res);
	return parsed;
};

export const curriedGetSessionLiveStreamDetails = (token: string) => (
	options: GetSessionLiveStreamDetailsOptions,
) => getSessionLiveStreamDetails(token, options);